import Bill from '@/generated/classes/Bill';
export default class BillExtend extends Bill {
  constructor() {
    super();
  }
}
